const GTM_ID = 'GTM-WRZNMQ6F'

if (import.meta.env.PROD) {
  // Head script
  const script = document.createElement('script')
  script.textContent = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');
  `
  document.head.appendChild(script)

  // Body noscript fallback
  const iframe = document.createElement('iframe')
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`
  iframe.height = '0'
  iframe.width = '0'
  iframe.style = 'display:none;visibility:hidden'

  const noscript = document.createElement('noscript')
  noscript.appendChild(iframe)

  // Додаємо після завантаження DOM
  window.addEventListener('DOMContentLoaded', () => {
    document.body.prepend(noscript)
  })
}
